export interface ErrorMessage {
    code: string;
    description: string;
}
